module.exports = __webpack_public_path__ + "img/duck.542c7a3e.svg";